import React__default from 'react';
import { FilesList } from '@grandvisionhq/common';
import ConfigurationSummaryDivider from '../ConfigurationSummaryDivider/ConfigurationSummaryDivider.js';
import { SummaryTitle } from '../SummaryTitle/SummaryTitle.js';

const PrescriptionUploadSummary = ({ title , uploadReferences , hideDividers  })=>{
    const filteredUploadedFileNames = Object.values(uploadReferences).reduce((m, ref)=>!ref ? m : [
            ...m,
            ref.fileName
        ]
    , []);
    return (filteredUploadedFileNames === null || filteredUploadedFileNames === void 0 ? void 0 : filteredUploadedFileNames.length) ? /*#__PURE__*/ React__default.createElement("section", {
        className: "prescription-upload-summary"
    }, /*#__PURE__*/ React__default.createElement(SummaryTitle, null, title), !hideDividers && /*#__PURE__*/ React__default.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider"
    }), /*#__PURE__*/ React__default.createElement(FilesList, {
        items: filteredUploadedFileNames
    }), !hideDividers && /*#__PURE__*/ React__default.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider--bottom"
    })) : null;
};

export { PrescriptionUploadSummary };
//# sourceMappingURL=PrescriptionUploadSummary.js.map
